import { useEffect } from 'react';

export const useAcknowledgeOpenChat = (conversationId, acknowledgeChat) => {
  useEffect(() => {
    if (!acknowledgeChat) return undefined;
    acknowledgeChat(conversationId || null);
    return () => {
      acknowledgeChat(null);
    };
  }, [conversationId, acknowledgeChat]);
};
